<template>
	<div style="width: 100%; height: 100%; margin: 0 auto">
		<div ref="chinaMap" style="float: left;width: 80%; height: 100%; margin: 0 auto"></div>
		<div style="float: left;width: 20%; height: 100%; margin: 0 auto">
			<div style="height: 100%;padding: 10px;">
				<el-table :data="cityschool" style="width: 100%;overflow: auto;" show-summary max-height="700" :default-sort = "{prop: 'schoolnum', order: 'descending'}">
					<el-table-column prop="cityname" sortable align="center" label="城市名称" > </el-table-column>
					<el-table-column prop="schoolnum" sortable label="校区数量"  align="center"></el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
	import chinajson from '/public/mapjson/china.json'
	import { queryCitySchoolNum } from '/static/apiUrl.js'
	export default {
		name : 'ChinaSchool',
		data() {
			return {
				option : {
					geo: {
						map: 'china',
						type:'map',
						itemStyle: {
							normal:{
								areaColor: 'rgba(27, 73, 135, 0.3)',
								borderColor: 'rgba(58, 128, 177, 0.4)',
							},
						},
						zoom: 1.2,          // 地图放大
						aspectScale: 0.8, //地图宽高比例
						roam:true,        //地图缩放、平移
						label: {
				            show: false,
				            textStyle: {
				                color: "rgba(246, 91, 39, 0.5)",
				            },
						},
						// 滚轮缩放的极限控制
						scaleLimit: { 
							min: 0.5, //缩放最小大小
							max: 6, //缩放最大大小
						},
					},
					series :[
						{
							type: 'scatter',
							coordinateSystem : 'geo',
							name: "校区数量",
							label : {
								show : true,
								position : "right",
								formatter : '{b}:{@[2]}个校区',
							},
							itemStyle : {
								color : "#fc5531",
							},
							Symbol : "circle",
							symbolSize : 10,
							data : [
								/* {
									name : "北京",
									value : ["116.41995", "40.18994", 20]
								} */
							]
						}
					],
				},
				mapchart : null,
				cityschool : [],
			}
		},
		components: {
			
		},
	    methods: {
	        initMap() {
				this.mapchart = this.$echarts.init(this.$refs.chinaMap);
				//console.log(myChart);
				let uploadDataUrl = chinajson;
				// 注册地图
				this.$echarts.registerMap("china", uploadDataUrl);
				this.mapchart.setOption(this.option);
	        },
			queryMapData(){
				this.option.series[0].data = []
				this.cityschool = []
				queryCitySchoolNum().then(res => {
					if(0 == res.code){
						res.datas.forEach((set) => {
							let citydata = [set.longtitude, set.latitude, set.schoolnum]
							this.option.series[0].data.push({
								name : set.cityname,
								value : citydata
							})
							this.cityschool.push({
								cityname : set.cityname,
								schoolnum : set.schoolnum
							})
						})
						console.log(this.cityschool)
						this.mapchart.setOption(this.option);
					}
				})
			},
			
	    },
	
	    // 此时，页面上的元素，已经被渲染完毕了！
	    mounted() {
	        //注意: dom 节点渲染结束后渲染echarts
	        this.initMap()
			this.queryMapData()
	    }
	}
</script>

<style>
</style>